import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';

const initialState = {
  customers: [],
  selectedCustomer: {
    balance: {
      '$numberDecimal': Number(0)
    }
  },
  submitStatus: '',
  getStatus: 'pending',
  selectedCustomerStatus: 'pending',
};


/**
 * Get all Customers - Basic
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const getCustomersBasic = createAsyncThunk(
  'customers/GetCustomersBasic',
  async (search, thunkAPI) => {
    try {
      const response = await axios.get(
        `${apiBaseURL}/api/v1/customers/all/basic/${search}`
      );
      console.log(response.data.customers);
      return response.data.customers;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);


/**
 * Get all Customers - Basic
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const getCustomersBasicList = createAsyncThunk(
  'customers/GetCustomersBasicList',
  async (thunkAPI) => {
    try {
      const response = await axios.get(
        `${apiBaseURL}/api/v1/customers/all/basic/`
      );
      return response.data.customers;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);


/**
 * Get Selected Customer
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const getSelectedCustomer = createAsyncThunk(
  'customers/GetSelectedCustomerDetails',
  async (payload, thunkAPI) => {
    try {
      console.log('customers/GetSelectedCustomerDetails', payload);
      const response = await axios.get(
        `${apiBaseURL}/api/v1/customers/${payload._id}`
      );
      return response.data.customer;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);


/**
 * Get all Customers
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
export const getCustomers = createAsyncThunk(
  'customers/GetCustomers',
  async (thunkAPI) => {
    try {
      const response = await axios.get(
        `${apiBaseURL}/api/v1/customers/allcustomers`
      );
      //console.log(response.data.customers);
      return response.data.customers;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

/**
 * Submit Customer
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const submitCustomer = createAsyncThunk(
  'customers/SubmitCustomer',
  async (payload, thunkAPI) => {
    // const { order } = payload;
    try {
      //console.log('[weighbridge - slice][submit order]', payload);
      const response = await axios.post(
        `${apiBaseURL}/api/v1/customers/`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

/**
 * Update Customer
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const updateCustomer = createAsyncThunk(
  'customers/UpdateCustomer',
  async ( payload,  thunkAPI) => {
    // const { order } = payload;
    try {
      const {data, customerId } = payload;
      const response = await axios.patch(
        `${apiBaseURL}/api/v1/customers/${customerId}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const setSelectedCustomer = customer => async dispatch => {
  dispatch(slice.actions.setSelectedCustomer(customer));
};

export const clearCustomerData = () => async dispatch => {
  dispatch(slice.actions.clearCustomerData(initialState));
};

const slice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setCustomers(state, action) {
      state.customers = action.payload;
    },
    setSelectedCustomer(state, action) {
      state.selectedCustomer = action.payload;
    },
    clearCustomerData(state, action) {
      return initialState;
    }
  },
  extraReducers: {
    [getCustomersBasicList.pending]: (state, action) => {
      state.getStatus = 'loading';
    },
    [getCustomersBasicList.fulfilled]: (state, action) => {
      state.customers = action.payload;
      state.getStatus = 'success';
    },
    [getCustomersBasicList.rejected]: (state, action) => {
      state.getStatus = 'failed';
    },
    [getCustomersBasic.pending]: (state, action) => {
      state.getStatus = 'loading';
    },
    [getCustomersBasic.fulfilled]: (state, action) => {
      state.customers = action.payload;
      state.getStatus = 'success';
    },
    [getCustomersBasic.rejected]: (state, action) => {
      state.getStatus = 'failed';
    },
    [getSelectedCustomer.pending]: (state, action) => {
      state.selectedCustomerStatus = 'loading';
    },
    [getSelectedCustomer.fulfilled]: (state, action) => {
      state.selectedCustomerStatus = 'success';
    },
    [getSelectedCustomer.rejected]: (state, action) => {
      state.selectedCustomerStatus = 'failed';
    },
    [getCustomers.pending]: (state, action) => {
      state.getStatus = 'loading';
    },
    [getCustomers.fulfilled]: (state, action) => {
      state.customers = action.payload;
      state.getStatus = 'success';
    },
    [getCustomers.rejected]: (state, action) => {
      state.getStatus = 'failed';
    },
    [submitCustomer.pending]: (state, action) => {
      state.submitStatus = 'loading';
    },
    [submitCustomer.fulfilled]: (state, action) => {
      state.submitStatus = 'success';
    },
    [submitCustomer.rejected]: (state, action) => {
      state.submitStatus = 'failed';
    },
    [updateCustomer.pending]: (state, action) => {
      state.submitStatus = 'loading';
    },
    [updateCustomer.fulfilled]: (state, action) => {
      state.submitStatus = 'success';
    },
    [updateCustomer.rejected]: (state, action) => {
      state.submitStatus = 'failed';
    }
  }
});

export const reducer = slice.reducer;

